/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SendingFacilityViewModel } from './sendingFacilityViewModel';
import { ProcedureViewModel } from './procedureViewModel';
import { DatasetViewModel } from './datasetViewModel';

export interface ProcedureLinkDetailsViewModel {
  id?: string;
  datasetId?: string;
  sendingFacilityId?: string;
  procedureId?: string | null;
  sendingFacilityProcedureCode?: string | null;
  sendingFacilityProcedureName?: string | null;
  ignore?: boolean;
  isDeleted?: boolean;
  deletedBy?: string | null;
  deletedDate?: string | null;
  createdBy?: string | null;
  createdDate?: string;
  updatedBy?: string | null;
  updatedDate?: string | null;
  dataset?: DatasetViewModel;
  procedure?: ProcedureViewModel;
  readonly description?: string | null;
  readonly code?: string | null;
  sendingFacility?: SendingFacilityViewModel;
  readonly sendingFacilityName?: string | null;
}
